module.exports = __webpack_public_path__ + "img/logo-edasinvoize.29118e43.webp";